package com.essntl.features.message.data.di

import com.essntl.features.message.data.repository.ConversationMockRepository
import com.essntl.features.message.data.repository.ConversationRepositoryImpl
import com.essntl.features.message.data.repository.MessageMockRepository
import com.essntl.features.message.data.repository.MessageRepositoryImpl
import com.essntl.features.message.domain.repository.ConversationRepository
import com.essntl.features.message.domain.repository.MessageRepository
import core.config.buildFlavor
import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module
import org.koin.dsl.module

@Module
@ComponentScan("com.essntl.features.message.data")
class MessageModule

val messageModule = module {
    // Conversation data fetched from DB
    single<ConversationRepository> {
        if (buildFlavor.isDemo) {
            ConversationMockRepository()
        } else {
            ConversationRepositoryImpl(
                whatsappClient = get()
            )
        }
    }

    // Message data fetched from DB
    single<MessageRepository> {
        if (buildFlavor.isDemo) {
            MessageMockRepository()
        } else {
            MessageRepositoryImpl(
                messageDataSource = get(),
                waypoint = get(),
                twilio = get(),
                whatsapp = get(),
            )
        }
    }
}